// == Import : npm
import { connect } from 'react-redux';

// == Import : local
import Pages from '../../screen/Pages';

// Action Creators
import { getAll } from '../../store/reducer';

const mapStateToProps = (state, ownProps) => ({
  datas: state.content_pages,
  waitingRequest: state.waitingRequest,
  connected: state.connected,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAll: (type, password) => {
    dispatch(getAll(type, ownProps.match.params.page, ownProps.history));
  },
});

// Container
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Pages);